import React, { useEffect, useState } from "react";
import AddSettlement from "./SettlementPage/AddSettlement";
import Toggle from "../../components/Toggle";
import { getSettlementAccount } from "../../services/settings";
import toast from "react-hot-toast";
import LoadingScreen from "../../components/LoadingScreen";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const Settlement = () => {
  const [settle, setSettle] = useState(true);
  const [addSettle, setAddSettle] = useState(false);
  const [settlements, setSettlements] = useState({});
  const [loading, setLoading] = useState(false);

  const handleSettlement = () => {
    setAddSettle(true);
    setSettle(false);
  };

  const handleGetSettlement = async () => {
    setLoading(true);
    try {
      const res = await getSettlementAccount();
      setSettlements(res.data || {});
      setLoading(false);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetSettlement();
  }, []);

  if (loading) {
    return <LoadingScreen title="Settings - Settlement" />;
  }

  const settlementList =
    settlements && Object.keys(settlements).length > 0 ? [settlements] : [];

  return (
    <>
      {settle && (
        <div className="max-w-72 overflow-hidden md:max-w-full">
          <div className="lg:flex items-center justify-between">
            <h1 className="text-2xl font-bold text-navy-blue">
              Settings - Settlement
            </h1>
            <Toggle />
          </div>

          {settlements && Object.keys(settlements).length === 0 ? (
            <div className="md:h-[924px] min-h-screen bg-white max-w-72 md:max-w-full mt-8 rounded-[10px] p-[1rem] md:p-[3rem]">
              <p className="w-[715px] lg:text-[50px] font-[700]">
                You have no settlement accounts
              </p>
              <div className="flex mt-4">
                <button
                  onClick={handleSettlement}
                  className="w-[272px] h-[42px] rounded-[8px] text-white bg-primary"
                >
                  + Add settlement account
                </button>
              </div>
            </div>
          ) : (
            <div className="h-[924px] rounded-[10px] p-[3rem] bg-white mt-6 shadow-sm">
              <section className="flex justify-between mb-4">
                <h1 className="font-medium text-3xl">My Settlements</h1>
              </section>
              <div className="mt-5">
                <DataTable
                  value={settlementList}
                  className="p-datatable-sm"
                  responsiveLayout="scroll"
                >
                  <Column
                    field="accountNumber"
                    header="Account Number"
                    body={(row) => (
                      <div className="py-2">{row?.accountNumber}</div>
                    )}
                  />
                  <Column
                    field="accountName"
                    header="Account Name"
                    body={(row) => (
                      <div className="py-2">{row?.accountName}</div>
                    )}
                  />
                  <Column
                    field="bvn"
                    header="BVN"
                    body={(row) => <div className="py-2">{row?.bvn}</div>}
                  />
                  <Column
                    field="bank"
                    header="Bank"
                    body={(row) => (
                      <div className="py-2">{row?.bank?.description}</div>
                    )}
                  />
                  <Column
                    field="currency"
                    header="Currency"
                    body={(row) => (
                      <div className="py-2">
                        {row?.currency?.description}
                      </div>
                    )}
                  />
                </DataTable>
              </div>
            </div>
          )}
        </div>
      )}
      {addSettle && (
        <div>
          <AddSettlement setAddSettle={setAddSettle} setSettle={setSettle} />
        </div>
      )}
    </>
  );
};

export default Settlement;
